// TODO: remove eslint disable
/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "components/complex/Header";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Alert,
  Table,
  ModalView
} from "components/simple";
import API from "api";
import { crm } from "router/routes";
import SVG from "components/SVG";
import Api from "../../../api";
import * as actions from "../../../store/actions/crm";
import { Collapse } from "reactstrap";
import {
  CompanyBaseInfo,
  CompanyPaymentInfo,
  CompanySubscription,
  CompanyAddUser,
  CompanyOwnerInfo
} from "../forms";
import { useForm, Controller } from "react-hook-form";
import { formatDate, formatDateToApi } from "helpers/formatter";
import DatePicker from "react-datepicker";
import styles from "./styles.module.scss";

const CompanyDeatails = props => {
  const dispatch = useDispatch();
  const {
    selectedCompany: company,
    countries,
    countryDatasets,
    categories,
    errors: responseErrors,
    staff,
    subscriptionCreating: isSubscriptionUpdating,
    audienceActivity
  } = useSelector(state => state.crm);
  const { match, history } = props;
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const [isShownModal, setIsShownModal] = useState(false);
  const [dates, setDates] = useState({
    startDate: null,
    endDate: null
  });

  const [isOwnerFormOpen, setIsOwnerFormOpen] = useState(false);
  const [isBaseInfoFormOpen, setIsBaseInfoFormOpen] = useState(false);
  const [isPaymentFormOpen, setIsPaymentFormOpen] = useState(false);
  const [isSubscriptionFormOpen, setIsSubscriptionFormOpen] = useState(false);
  const [isAddUserFormOpen, setIsAddUserFormOpen] = useState(false);

  const {
    formState: { errors },
    control,
    setError,
    reset,
    clearErrors
  } = useForm();

  useEffect(() => {
    const { id } = match.params;

    if (countries.length === 0) {
      Api.crm.getCountries();
    }
    if (countryDatasets.length === 0) {
      Api.crm.getCoutryDatasets();
    }
    if (categories.length === 0) {
      Api.crm.getCategories();
    }
    if (staff.length === 0) {
      Api.crm.getStaff();
    }
    Api.crm.getCompany(id);
    return () => {
      dispatch(actions.removeCompanyInfo());
    };
  }, []);

  useEffect(() => {
    if (responseErrors) {
      Object.keys(responseErrors).forEach(key => {
        setError(key, {
          type: "manual",
          message:
            responseErrors[key] instanceof Array
              ? responseErrors[key].toString()
              : responseErrors[key]
        });
      });
    } else {
      clearErrors();
    }
  }, [responseErrors]);

  const handleCompanyRemove = async () => {
    await Api.crm.removeCompany(company.id);
    history.replace("/crm");
  };

  const submitBaseInfoChange = async data => {
    await Api.crm.editCompanyInfo(
      {
        ...data,
        country: data?.country?.value,
        created_by: data?.created_by?.value
      },
      company.id
    );
  };

  const submitOwnerInfoChange = async data => {
    await Api.crm.editCompanyInfoOwner(
      {
        owner: data?.owner?.value
      },
      company.id
    );
  };

  const submitPaymentInfoUpdate = async data => {
    if (company.paymentInfo) {
      await Api.crm.editCompanyPaymentIndo(
        { ...data, company: company.id },
        company.paymentInfo.id
      );
    } else {
      await Api.crm.createPaymentInfo({ ...data, company: company.id });
    }
  };

  const submitSubscriptionUpdate = async data => {
    let dataForSubmit = {
      additional_categories:
        data?.additional_categories?.map(({ item }) => item.id) || [],
      excluded_categories:
        data?.excluded_categories?.map(({ item }) => item.id) || [],
      country_datasets:
        data?.country_datasets?.map(({ item }) => item.id) || [],
      expiration_date: formatDate(data?.expiration_date, "YYYY-MM-DD"),
      subscriptionType: data?.subscription_type?.value,
      company: company?.id,
      download_data: data?.download_data,
      show_affinity_numbers: data?.show_affinity_numbers
    };

    if (company?.subscription) {
      await Api.crm.editCompanySubscription(
        { ...dataForSubmit },
        company?.subscription?.id
      );
    } else {
      await Api.crm.createSubscription({
        ...dataForSubmit
      });
    }
  };

  const submitInviteUser = async user => {
    await Api.crm.addCompanyUser(user, company.id);
  };

  const { isDownloaded, isActivityLoading, data, fileName } = audienceActivity;

  const resetFormAndToggleModal = () => {
    setIsShownModal(prev => !prev);
    reset({ start_date: "", end_date: "" });
    setDates({
      startDate: null,
      endDate: null
    });
    dispatch(actions.resetErrorsAudienceActivity());
  };

  useEffect(() => {
    if (
      isDownloaded &&
      !audienceActivity.errors &&
      !isActivityLoading &&
      data &&
      fileName &&
      isShownModal
    ) {
      setIsShownModal(false);
      reset({ start_date: "", end_date: "" });
      setDates({
        startDate: null,
        endDate: null
      });
      const downloadLink = document.createElement("a");
      const blob = new Blob(["\ufeff", data]);
      const url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }, [isActivityLoading, isDownloaded, audienceActivity.errors]);

  const getAudienceActivity = () => {
    API.crm.getAudienceActivity({ id: company.id, dates: dates });
  };

  const submit = () => {
    getAudienceActivity();
  };

  useEffect(() => {
    API.crm.getCompanies();
  }, []);

  useEffect(() => {
    if (Object.keys(errors).length === 0) {
      setIsBaseInfoFormOpen(false);
      setIsPaymentFormOpen(false);
      setIsSubscriptionFormOpen(false);
      setIsAddUserFormOpen(false);
      setIsOwnerFormOpen(false);
    }
  }, [errors, company]);

  const removeUser = id => {
    Api.crm.removeUser(id);
  };

  const handleGoBack = () => {
    history.replace(`${crm}/companies`);
  };

  return (
    <>
      <Container fluid id="audiences">
        <div className="audiences-background">
          <div className="background-light" />
        </div>
        <Container>
          <Row>
            <Header withoutSearchAndNotifications={false} />
          </Row>
          <Row>
            <Col xs={12}>
              <div className={styles["btns-wrapper"]}>
                <div>
                  <div className="d-flex">
                    <Button
                      className="bg-transparent border-0 rotate-180"
                      onClick={handleGoBack}
                    >
                      <SVG.Arrow fill="black" stroke="black" />
                    </Button>
                    <h1>{company?.name}</h1>
                  </div>
                </div>
                <Button
                  onClick={() => setIsShownModal(true)}
                  className={`button add-button ${styles["btn-fixed"]}`}
                >
                  <SVG.Plus className="icon" />
                  <span>Download report</span>
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
        <Container className="pt-5">
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <Alert color="info">
                    <Row className="pt-2">
                      <Col xs={12} sm={4}>
                        <h5>Country:</h5>
                      </Col>
                      <Col xs={12} sm={8}>
                        {company?.country?.name}
                      </Col>
                      <Col xs={12} sm={4}>
                        <h5>Created by:</h5>
                      </Col>
                      <Col xs={12} sm={8}>
                        {company?.createdBy}
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        className="justify-content-end flex-row d-flex"
                      >
                        <Button
                          onClick={() =>
                            setIsBaseInfoFormOpen(!isBaseInfoFormOpen)
                          }
                        >
                          Edit
                        </Button>
                      </Col>
                      <Col xs={12}>
                        <Collapse
                          isOpen={isBaseInfoFormOpen}
                          onExited={() => {
                            reset();
                          }}
                        >
                          <CompanyBaseInfo
                            onSubmit={submitBaseInfoChange}
                            countries={countries}
                            company={company}
                            staff={staff}
                            errors={errors}
                            isEdit={true}
                          />
                        </Collapse>
                      </Col>
                    </Row>
                  </Alert>
                  <Alert color="info">
                    <Row className="pt-2">
                      <Col xs={12} sm={4}>
                        <h5>Owner:</h5>
                      </Col>
                      <Col xs={12} sm={8}>
                        {company?.owner?.name || company?.owner?.email}
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        className="justify-content-end flex-row d-flex"
                      >
                        {!!company?.members?.length && (
                          <Button
                            onClick={() => setIsOwnerFormOpen(prev => !prev)}
                          >
                            Edit
                          </Button>
                        )}
                      </Col>
                      <Col xs={12}>
                        <Collapse
                          isOpen={isOwnerFormOpen}
                          onExited={() => {
                            reset();
                          }}
                        >
                          <CompanyOwnerInfo
                            onSubmit={submitOwnerInfoChange}
                            members={company?.members}
                            owner={company?.owner}
                            errors={errors}
                            isEdit={true}
                          />
                        </Collapse>
                      </Col>
                    </Row>
                  </Alert>
                  <Alert color="info">
                    <Row className="pt-2">
                      <Col xs={12} sm={4}>
                        <h5>Payment Info:</h5>
                      </Col>
                      <Col xs={12} sm={8} />
                      <Col xs={12} sm={{ offset: 1, size: 3 }} offset={2}>
                        - Address 1:
                      </Col>
                      <Col xs={12} sm={8}>
                        {company?.paymentInfo?.address_1}
                      </Col>
                      <Col xs={12} sm={{ offset: 1, size: 3 }} offset={2}>
                        - Address 2:
                      </Col>
                      <Col xs={12} sm={8}>
                        {company?.paymentInfo?.address_2}
                      </Col>
                      <Col xs={12} sm={{ offset: 1, size: 3 }} offset={2}>
                        - Email:
                      </Col>
                      <Col xs={12} sm={8}>
                        {company?.paymentInfo?.companyEmail}
                      </Col>
                      <Col xs={12} sm={{ offset: 1, size: 3 }} offset={2}>
                        - Company ID:
                      </Col>
                      <Col xs={12} sm={8}>
                        {company?.paymentInfo?.idNumber}
                      </Col>
                      <Col xs={12} sm={{ offset: 1, size: 3 }} offset={2}>
                        - Notes:
                      </Col>
                      <Col xs={12} sm={8}>
                        {company?.paymentInfo?.notes}
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        className="justify-content-end flex-row d-flex"
                      >
                        <Button
                          onClick={() =>
                            setIsPaymentFormOpen(!isPaymentFormOpen)
                          }
                        >
                          Edit
                        </Button>
                      </Col>
                      <Col xs={12}>
                        <Collapse
                          isOpen={isPaymentFormOpen}
                          onExited={() => {
                            reset();
                          }}
                        >
                          <CompanyPaymentInfo
                            onSubmit={submitPaymentInfoUpdate}
                            errors={errors}
                            paymentInfo={company?.paymentInfo}
                          />
                        </Collapse>
                      </Col>
                    </Row>
                  </Alert>
                  <Alert color="info">
                    <Row className="pt-2">
                      <Col xs={12}>
                        <h5>Subscription info:</h5>
                      </Col>
                      <Col xs={12} sm={{ offset: 1, size: 3 }}>
                        - Subscription type:
                      </Col>
                      <Col xs={8}>
                        {company?.subscription?.subscriptionType}
                      </Col>
                      <Col xs={12} sm={{ offset: 1, size: 3 }}>
                        - Expiration date:
                      </Col>
                      <Col xs={8}>{company?.subscription?.expirationDate}</Col>
                      <Col xs={12} sm={{ offset: 1, size: 3 }}>
                        - Country datasets:
                      </Col>
                      <Col xs={8}>
                        {company?.subscription?.countryDatasets
                          ?.map(item => {
                            return item.name;
                          })
                          .join(",")}
                      </Col>
                      <Col xs={12} sm={{ offset: 1, size: 3 }}>
                        - Additional categories:
                      </Col>
                      <Col xs={8}>
                        {company?.subscription?.additionalCategories
                          .map(item => {
                            return item.name;
                          })
                          .join(", ")}
                      </Col>
                      <Col xs={12} sm={{ offset: 1, size: 3 }}>
                        - Excluded categories:
                      </Col>
                      <Col xs={8}>
                        {company?.subscription?.excludedCategories
                          .map(item => {
                            return item.name;
                          })
                          .join(", ")}
                      </Col>
                      <Col xs={12} sm={{ offset: 1, size: 3 }}>
                        - Show affinity numbers:
                      </Col>
                      <Col xs={8}>
                        {company?.subscription?.showAffinityNumbers
                          ? "Yes"
                          : "No"}
                      </Col>
                      <Col xs={12} sm={{ offset: 1, size: 3 }}>
                        - Download data:
                      </Col>
                      <Col xs={8}>
                        {company?.subscription?.downloadData ? "Yes" : "No"}
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        className="justify-content-end flex-row d-flex"
                      >
                        <Button
                          onClick={() =>
                            setIsSubscriptionFormOpen(!isSubscriptionFormOpen)
                          }
                        >
                          Edit
                        </Button>
                      </Col>

                      <Col xs={12}>
                        <Collapse
                          isOpen={isSubscriptionFormOpen}
                          onExited={() => {
                            reset();
                          }}
                        >
                          <CompanySubscription
                            onSubmit={submitSubscriptionUpdate}
                            errors={errors}
                            allCountryDatasets={countryDatasets}
                            categories={categories}
                            subscription={company?.subscription}
                          />
                        </Collapse>
                      </Col>
                    </Row>
                  </Alert>
                  <Alert color="info">
                    <Row className="pt-2">
                      <Col xs={12}>
                        <h5>Company members: </h5>
                      </Col>
                      <Col
                        xs={{ offset: 1, size: 11 }}
                        className="d-flex flex-column"
                      >
                        {company?.members?.length > 0 ? (
                          <Table className="table-striped">
                            <thead>
                              <tr>
                                <th scope="col">Email</th>
                                <th scope="col">Name</th>
                                <th scope="col">Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {company?.members.map(
                                ({ active, email, id, name }) => {
                                  return (
                                    <tr key={id}>
                                      <td>{email}</td>
                                      <td>{name}</td>
                                      <td>{active ? "Active" : "Invited"}</td>
                                      <td className="text-center">
                                        <Button
                                          type="button"
                                          onClick={() => removeUser(id)}
                                        >
                                          Delete
                                        </Button>
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </Table>
                        ) : (
                          <h6 className="pt-3">
                            The company has no members yet
                          </h6>
                        )}
                      </Col>
                      <Col
                        xs={{ offset: 1, size: 11 }}
                        className="d-flex justify-content-end pt-2 pb-2"
                      >
                        <Button
                          onClick={() =>
                            setIsAddUserFormOpen(!isAddUserFormOpen)
                          }
                        >
                          Invite new user
                        </Button>
                      </Col>
                      <Col xs={12}>
                        <Collapse
                          isOpen={isAddUserFormOpen}
                          onExited={() => {
                            reset();
                          }}
                        >
                          <CompanyAddUser
                            onSubmit={submitInviteUser}
                            errors={errors}
                            companyName={company?.name}
                          />
                        </Collapse>
                      </Col>
                    </Row>
                  </Alert>

                  <Alert color="info">
                    <Row>
                      <Col xs={12}>
                        <Table>
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Activity Type</th>
                              <th>Platform</th>
                              <th>Client</th>
                              <th>Created At</th>
                            </tr>
                          </thead>
                          <tbody>
                            {company?.audienceActivity?.map(
                              ({
                                activityType,
                                client,
                                createdAt,
                                name,
                                platform
                              }) => {
                                return (
                                  <tr>
                                    <td>{name}</td>
                                    <td>{activityType}</td>
                                    <td>{platform}</td>
                                    <td>{client}</td>
                                    <td>{createdAt}</td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Alert>
                  <Col xs={12} className="text-center">
                    <Button
                      className="btn-lg btn-danger"
                      onClick={handleCompanyRemove}
                    >
                      Remove Company
                    </Button>
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Container>
      <ModalView
        isOpen={isShownModal}
        toggle={resetFormAndToggleModal}
        handleClose={resetFormAndToggleModal}
        backdrop
        size="lg"
      >
        <div className={styles["picker-wrapper"]}>
          <Controller
            control={control}
            name="start_date"
            id="start_date"
            render={({ field }) => (
              <DatePicker
                className="form-control"
                ref={startDateRef}
                placeholderText="Select start date"
                maxDate={dates.endDate ? new Date(dates.endDate) : null}
                dateFormat="yyyy-MM-dd"
                onChange={date => {
                  field.onChange(date);
                  setDates(prev => {
                    return { ...prev, startDate: formatDateToApi(date) };
                  });
                }}
                selected={field.value}
              />
            )}
          />
          <Controller
            control={control}
            name="end_date"
            id="end_date"
            render={({ field }) => (
              <DatePicker
                className="form-control"
                ref={endDateRef}
                placeholderText="Select end date"
                minDate={dates.startDate ? new Date(dates.startDate) : null}
                dateFormat="yyyy-MM-dd"
                onChange={date => {
                  field.onChange(date);
                  setDates(prev => {
                    return { ...prev, endDate: formatDateToApi(date) };
                  });
                }}
                selected={field.value}
              />
            )}
          />
          <span className={styles["modal-error"]}>
            {audienceActivity?.errors}
          </span>
          <Button onClick={submit} className="button">
            <span>Download report</span>
          </Button>
        </div>
      </ModalView>
    </>
  );
};

export default CompanyDeatails;
